// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__3i13p","grid":"styles_grid__2TGE1"};